// Compose screen tokens (itinerary-generator.pen · qabcA)
$gen-ink: #121926;
$gen-brand: #8b5cf6;
$gen-brand-surface: #f5f3ff;
$gen-brand-border: #e9d5ff;
$gen-brand-text: #6d28d9;
$gen-border: #e2e8f0;
$gen-muted: #64748b;

.root {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 14px 14px;
}

.modeTabs {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.modeTab {
  align-items: center;
  background: #ffffff;
  border: 1px solid $gen-border;
  border-radius: 18px;
  color: $gen-ink;
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  font-weight: 600;
  gap: 6px;
  padding: 6px 10px;
}

.modeTab:hover:not(.modeTabIsActive) {
  border-color: #cbd5e1;
}

.modeTabIsActive {
  background: $gen-ink;
  border-color: $gen-ink;
  color: #ffffff;
}

.modeTabCount {
  align-items: center;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  display: inline-flex;
  font-size: 10px;
  justify-content: center;
  min-width: 16px;
  padding: 1px 4px;
}

.modeTab:not(.modeTabIsActive) .modeTabCount {
  background: #f1f5f9;
  color: $gen-muted;
}

.sortRow {
  align-items: center;
  display: flex;
  flex: 1;
  font-size: 10px;
  font-weight: 500;
  gap: 4px;
  justify-content: flex-end;
  min-width: 0;
  padding: 2px 0;
}

.sortLabel {
  color: $gen-muted;
}

.justificationBar {
  align-items: center;
  background: $gen-brand-surface;
  border: 1px solid $gen-brand-border;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  padding: 8px 10px;
}

.justificationAiBadge {
  background: $gen-brand;
  border-radius: 4px;
  color: #ffffff;
  font-size: 9px;
  font-weight: 700;
  padding: 1px 5px;
}

.justificationText {
  color: $gen-brand-text;
  font-size: 11px;
  font-weight: 500;
}

.searchBar {
  align-items: center;
  background: #ffffff;
  border: 1px solid $gen-border;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  padding: 8px 10px;
}

.searchIcon {
  color: #94a3b8;
}

.searchInput {
  border: 0;
  flex: 1 1 auto;
  font-size: 12px;
  outline: none;

  &::placeholder {
    color: #94a3b8;
  }
}

.searchBrowse {
  background: #f8fafc;
  border: 1px solid $gen-border;
  border-radius: 6px;
  color: $gen-ink;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
}

.cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.metaRow {
  align-items: center;
  background: #f8fafc;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  padding: 8px 10px;
}

.metaText {
  color: $gen-ink;
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 600;
}

.metaDivider {
  background: $gen-border;
  height: 12px;
  width: 1px;
}

.metaAiBadge {
  background: $gen-brand-surface;
  border-radius: 4px;
  color: $gen-brand-text;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 5px;
}

.metaManualBadge {
  background: #f1f5f9;
  border-radius: 4px;
  color: $gen-muted;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 5px;
}

.metaTotal {
  font-size: 12px;
  font-weight: 700;
}

.footer {
  border-top: 1px solid $gen-border;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 4px -14px 0;
  padding: 8px 16px 0;
}

.footerRow {
  display: flex;
  gap: 8px;
}

.footerBtn {
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  height: 38px;
  justify-content: center;
  padding: 0 14px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.footerBtnOutline {
  background: #ffffff;
  border: 1px solid $gen-border;
  color: $gen-ink;
}

.footerBtnPrimary {
  background: $gen-ink;
  border: 0;
  color: #ffffff;
  gap: 6px;
}

.footerHint {
  color: $gen-muted;
  font-size: 10px;
  text-align: center;
}
